import React from "react"

class BubbleNotification extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      ...props
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ ...nextProps })
  }

  render() {
    const { notificationCount } = this.state
    
    return(
      <span className='bubble-btn'>
        { notificationCount > 0 && <span className='bubble'>{notificationCount}</span> }
      </span>
    )
  }
}

export default BubbleNotification;
